import { useTranslation } from 'react-i18next';

import styles from './ChangePasswordForm.module.scss';

interface PasswordRequirementsProps {
  validationRules: string[]
}

const PasswordRequirements = ({ validationRules }: PasswordRequirementsProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.passwordRequirements}>
      <span className={styles.passwordRequirementsTitle}>
        {t('changePasswordForm.passwordRequirements.title')}
      </span>
      <div className={styles.passwordRequirementsContent}>
        <span className={styles.passwordRequirementsContentTitle}>{t('changePasswordForm.passwordRequirements.content')}</span>
        <ul className={styles.passwordRequirementsList}>
          {validationRules.map((item, i) => <li key={i}>{item}</li>)}
        </ul>
      </div>
    </div>
  );
};

export default PasswordRequirements;
